import React, { useEffect } from 'react';
import { checkNetwork } from '../service/api/token';

const UnAuthGuard = ({ component }) => {
    const [networkOk, setNetworkOk] = React.useState(false);



    const healthcheck = () => {
        if (!networkOk) {
            setNetworkOk(checkNetwork());

        } else {
            // throw new Error("QWERT")

        }
    }

    useEffect(() => {
        healthcheck()


    }, [component]);

    return <React.Fragment>{component}</React.Fragment>
}

export default UnAuthGuard;